import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CompartirService } from '../../services/compartir.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-vendedor-respuesta-comentarios',
  templateUrl: './vendedor-respuesta-comentarios.component.html',
  styleUrls: ['./vendedor-respuesta-comentarios.component.scss'],
})
export class VendedorRespuestaComentariosComponent implements OnInit, OnDestroy {
  @Input() productId;
  @Input() userId;
  myUser;
  avatarFile = `${environment.url}/file`
  comentario:string = '';
  comments:any[] = [];
  sending = false;
  commentSus:Subscription;
  answeringReply;
  answering;
  defaultAvatar = '/assets/img/icons/categoria-materiaprima.svg';
  avatar = `${this.avatarFile}/`

  constructor(
    private compartirService:CompartirService,
    private storageService:StorageService,
    private toastService:ToastService
  ) { }

  async ngOnInit() {

    this.myUser = await this.storageService.get('userLogin');
    this.compartirService.showComments(0, this.productId).subscribe((res:any) => {
      
      if(res.status){
        this.comments = res.data.reverse();        
      }
    })
  }

  async buscar(ev: any, to, id?) {
    const code = ev.keyCode || ev.which;
    if (code === 13) {
      if(to === 'new'){
        this.comentar()
      }else{    
        if(!ev.target.value.trim()){
          return this.toastService.show('Debe contener mas de 1 carácter')
        }else{
          this.reply(id, ev.target.value)
          ev.target.value = '';
        } 
      }
    }
  }

  comentar(){
    if(!this.comentario.trim()){
      return this.toastService.show('Debe contener mas de 1 caracter')
    }
    this.sending = true;

    const obj:any = {
      productId: this.productId,
      comment: this.comentario,
      child: []
    };

    this.commentSus = this.compartirService.postComment(obj).subscribe(res => {
      const myComment = {
        ...obj,
        user: {
          file: this.myUser.file,
          name: this.myUser.name
        },
        created_at: new Date()
      }
      this.comments.unshift(myComment)
      this.sending = false;
    }, err => {
        if(err.status === 401){
          this.toastService.show('Debes iniciar sesion para poder comentar');
        }
      }
    );
    this.comentario = '';
  }

  ngOnDestroy(): void {
    // this.commentSus.unsubscribe()
  }

  selectReply(id){
    this.answering = id;
  }

  reply(id, comment){
    this.answeringReply = true;
    const obj:any = {
      productId: this.productId,
      comment: comment,
      parentId: id
    }
    this.commentSus = this.compartirService.postComment(obj).subscribe(res => {
      this.answeringReply = false;
      const parentComment = this.comments.find(x => x.id === id);      
      parentComment.child.push({
        comment: comment,
        user: {
          file: this.myUser.file,
          name: this.myUser.name
        },
      })
      comment = '';
    });
  }

  handleMissingImage(event){
    (event.target as HTMLImageElement).src = this.defaultAvatar;
  }

}
